import React from 'react'
import { Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import MANDATORY_Doc_data from '../../Assets/JSON/IQAC/Mandatory.json'

const MANDATORY_Doc = () => {
  // const [open, setOpen] = React.useState(false);

  const navigate = useNavigate()
  // const handleClose = (event, reason) => {
  //   if (reason === "clickaway") {
  //     return;
  //   }
  //   setOpen(false);
  // };
  const navigation_url = (path) => {
    if (path.fileUrl === '') {
    } else {
      navigate('/mandatorydoc/' + path.id + '/' + path.pathurl)
    }
  }
  return (
    <section className="container py-4">
      <>
        <div>
          <Typography variant="h6" component="div" sx={{ my: 2 }}>
            {MANDATORY_Doc_data.title}
          </Typography>
        </div>
        <div>
          <p>{MANDATORY_Doc_data.description}</p>
        </div>
        <div>
          {MANDATORY_Doc_data.documents.map((item) => (
            <div className="my-4" key={item.title}>
              <Typography variant="h6" component="div" sx={{ my: 2 }}>
                {item.title}
              </Typography>
              <div>
                <small
                  style={{
                    cursor: item.fileUrl === '' ? 'not-allowed' : 'pointer',
                    color: item.fileUrl === '' ? 'gray' : 'inherit',
                  }}
                  onClick={() => navigation_url(item)}
                >
                  {item.filename}
                </small>
              </div>
            </div>
          ))}
        </div>
      </>
    </section>
  )
}

export default MANDATORY_Doc
